import ProductMatchingBikeSelectionWidget
    from 'PyzShopUi/scripts/product-detail-page/includes/product-configurator/includes/widget/ProductMatchingBikeSelectionWidget';
import ProductBikeSearchSuggestionWidget
    from 'PyzShopUi/scripts/product-detail-page/includes/product-configurator/includes/widget/ProductBikeSearchSuggestionWidget';
import MyBikeRadioButtonWidget
    from 'PyzShopUi/scripts/product-detail-page/includes/product-configurator/includes/widget/MyBikeRadioButtonWidget';
import ProductFilterWidget
    from 'PyzShopUi/scripts/product-detail-page/includes/product-configurator/includes/widget/ProductFilterWidget';
import {
    createUpdateProductInformationFunction
} from 'PyzShopUi/scripts/product-detail-page/includes/variant-helper/selectFilter';

export default class ProductConfiguratorHandler {
    public static init = (articleMainInfoElement: HTMLElement): void => {
        const initProductInfoFunction = this.createInitProductInfoFunction(articleMainInfoElement);

        ProductBikeSearchSuggestionWidget.init(articleMainInfoElement, initProductInfoFunction);
        MyBikeRadioButtonWidget.init(articleMainInfoElement, initProductInfoFunction);
        ProductMatchingBikeSelectionWidget.init(articleMainInfoElement,initProductInfoFunction);
        ProductFilterWidget.init(articleMainInfoElement, initProductInfoFunction);
    };

    private static createInitProductInfoFunction = (articleMainInfoElement: HTMLElement) => {
        const addToCartFormElement: HTMLFormElement = articleMainInfoElement.querySelector('add-to-cart-form');
        const productResponseElement: HTMLElement = articleMainInfoElement.querySelector('[data-product-client-response]');
        const productResponse = JSON.parse(productResponseElement.dataset.productClientResponse);

        return createUpdateProductInformationFunction(addToCartFormElement, productResponse);
    }
}
